import { useState } from "react";
import BoxControls from "../../Common/Box/BoxControls";
import SectorChooser from "../../Common/Box/Choosers/SectorChooser";
import Figure from "../../Common/Box/Figure";
import initialData from "../../../data/initialData.json";
import useAreaQuery from "../../../hooks/useAreaQuery";
import { getSector, getTooltip } from "../../../utilities";

const number = 11;

const getSeriesColor = (name, theme) => {
  switch (name) {
    case "Sterilization":
      return theme.palette.areas.contraception.methods.sterilization;

    case "Implant":
      return theme.palette.areas.contraception.methods.implant;

    case "IUD":
      return theme.palette.areas.contraception.methods.iud;

    case "Injectable":
      return theme.palette.areas.contraception.methods.injectable;

    case "Pill":
      return theme.palette.areas.contraception.methods.pill;

    case "Condom":
      return theme.palette.areas.contraception.methods.condom;

    case "Other":
      return theme.palette.areas.contraception.methods.other;

    default:
      return "black";
  }
};

const options = (data) => (theme) => {
  const series = data.map((series) => ({
    ...series,
    color: getSeriesColor(series.name, theme),
  }));

  return {
    chart: {
      type: "column",
      width: 470,
      height: 300,
      backgroundColor: null,
    },
    xAxis: {
      categories: ["Users", "Costs"],
      title: undefined,
      labels: {
        autoRotation: undefined,
        useHTML: true,
        style: {
          color: theme.figure.axis.primary,
          fontSize: theme.figure.axis.fontSize,
        },
      },
    },
    yAxis: {
      title: undefined,
      reversedStacks: false,
      labels: {
        format: "{value}%",
        style: {
          color: theme.figure.axis.secondary,
          fontSize: theme.figure.axis.fontSize,
        },
      },
    },
    plotOptions: {
      column: {
        stacking: "percent",
        pointWidth: 30,
        borderWidth: 0,
      },
    },
    legend: {
      align: "right",
      verticalAlign: "middle",
      layout: "vertical",
      reversed: true,
      itemStyle: {
        fontSize: theme.figure.legend.fontSize,
      },
    },
    tooltip: {
      backgroundColor: "white",
      useHTML: true,
      outside: true,
      formatter: function () {
        const indicator = this.x === "Costs" ? "Cost" : "Users";

        return getTooltip(indicator, this.y, this.percentage, {
          prefix: indicator === "Cost" ? "$" : undefined,
        });
      },
      style: {
        fontSize: "0.875rem",
        color: theme.palette.tooltip.primary,
      },
    },
    exporting: {
      chartOptions: {
        title: undefined,
        subtitle: undefined,
      },
      enabled: false,
    },
    series,
  };
};

const Component = () => {
  const [selectedSectorId, setSelectedSectorId] = useState(0);

  const { areaData: data } = useAreaQuery(
    `/fp/figures/11/${selectedSectorId}`,
    initialData["fp_f11"]
  );

  const handleSectorChange = (methodId) => {
    setSelectedSectorId(methodId === 4 ? 0 : methodId);
  };

  return (
    <Figure
      id="FP_f11"
      number={number.toString()}
      fileStem={`fp_f${number}`}
      title="Contraceptive Use vs Supply Cost"
      subtitle="By Method, 2019"
      selection={getSector(selectedSectorId)}
      controls={
        <BoxControls>
          <SectorChooser
            value={selectedSectorId}
            onChange={handleSectorChange}
          />
        </BoxControls>
      }
      chartOptions={options(data)}
    />
  );
};

export default Component;
